import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import ReportStatementDetails from '../report-statement-details';
import ReportRMDetails from '../report-rm-details';
import ReportCustomDetails from '../report-custom-details';
import { ReportTypes } from '../constants'
import ReportPortfolioSelector from '../../../components/app/report-portfolio';

class ReportCategoryDetailsParent extends Component {

  render() {
    const { app, reports: { selectedReportType } } = this.props;
    const isTablet = app.global.deviceInfo.isTablet;

    return (
      <View >
        {
          !isTablet &&
          <View style={{ marginBottom: 20 }}><ReportPortfolioSelector /></View>
        }

        {/* {selectedReportType === ReportTypes.STATEMENTS && <ReportStatementDetails />} */}

        {<ReportStatementDetails />}
        {selectedReportType === ReportTypes.RECEIVED_FROM_RM && <ReportRMDetails />}

      </View>
    );
  }
}

ReportCategoryDetailsParent.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  app: PropTypes.object,
  report: PropTypes.object
};

ReportCategoryDetailsParent.defaultProps = {
  i18n: {},
  reports: {}
};

export default createContainer({
  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    reports: {
      selectedReportType: true,
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    dailyPdf: {
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      },
    },
    resetAdvicesDates: { $call: 'advices.resetDates' },
    resetReportsDates: { $call: 'reports.resetDates' },
    portfolio: {
      netIncome: {
        value: true,
      },
    },
  },
})(ReportCategoryDetailsParent);
